import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [time, setTime] = useState(14 * 60 + 50); // 14 minutes 50 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(prev => {
        if (prev <= 0) {
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return <div className="bg-black text-white py-1 px-3 text-center font-semibold text-xs sticky top-0 z-50 shadow-sm" data-id="element-4">
      <div className="flex items-center justify-center gap-1.5" data-id="element-5">
        <Clock className="w-3 h-3 text-yellow-400" data-id="element-6" />
        <span data-id="element-7">
          ⏳ OFERTA EXPIRA EN:{' '}
          <span className="text-yellow-400 text-xs font-mono font-bold" data-id="element-8">
            {String(minutes).padStart(2, '0')}:
            {String(seconds).padStart(2, '0')}
          </span>{' '}
          | 🔥 CUPOS LIMITADOS
        </span>
      </div>
    </div>;
}